import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextCard from '../../components/TextComps/TextCard'
import TextCardPgx from './TextCardPgx';
import TextCardBold from './TextCardBold';
import { useTheme } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import PanelLinePgx from './PanelLinePgx';
import Divider from '@mui/material/Divider';


export default function PgxAccordion({drugname, source, g, gt, ph, genename, genotype, phenotype, gl, gl_name, url, url_name, pop, pop_name, imp, imp_name, rec, rec_name, clas, clas_name, alt, alt_name, }) {

  const theme = useTheme();
  
    return (

theme.palette.mode === "light" ? (

  <Box sx={{mb:2.5}}>
      <Accordion elevation={3} sx={{mb:2, bgcolor: 'grey.C200', }}>     
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
           <PanelLinePgx 
                marker = {<TextCardPgx textcard={drugname} />}
                source = {<TextCardPgx textcard={source} />}
           /> 
        </AccordionSummary> 
     
  <AccordionDetails sx={{}}>
    
    <Grid container sx={{mb:2, p:3, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',  borderRadius: '10px', border: 'groove', }}> 
      
      <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', mb:1, pl:0.5 }}> <TextCardBold textcard={g} /> </Grid>
      <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', mb:1 }}> <TextCardBold textcard={gt} /> </Grid>
      <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', mb:1 }}> <TextCardBold textcard={ph} /> </Grid>
      
      <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', pb:1}}> {genename} </Grid> 
      <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', pb:1}}> <TextCard textcard= {genotype} /> </Grid> 
      <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', pb:1}}> <TextCard textcard= {phenotype} /> </Grid> 

      <Grid size={12}>  <Divider role="presentation" sx={{mt:2, mb:2, borderBottomWidth: '1px', borderBottomColor: 'common.black' }}/> </Grid>

      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',mb:0.5 }}> <TextCardBold textcard={gl} /> </Grid>
      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',pb:1}}>  <TextCard textcard={gl_name} /> </Grid> 
      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',mb:0.5}}> <TextCardBold textcard={pop} /> </Grid>
      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',pb:1}}>  <TextCard textcard={pop_name} /> </Grid> 

      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',mb:0.5 }}> <TextCardBold textcard={imp} /> </Grid>
      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',pb:1}}>  <TextCard textcard={imp_name} /> </Grid> 
      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', mb:0.5}}> <TextCardBold textcard={rec} /> </Grid>
      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',pb:1}}>  <TextCard textcard={rec_name} /> </Grid> 
      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',mb:0.5 }}> <TextCardBold textcard={clas} /> </Grid>
      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',pb:1}}>  <TextCard textcard={clas_name} /> </Grid> 

      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',mb:0.5}}> <TextCardBold textcard={alt} /> </Grid>
      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',pb:1}}>  <TextCard textcard={alt_name} /> </Grid> 
      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', mb:0.5}}> <TextCardBold textcard={url} /> </Grid>
      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',pb:1}}>  <TextCard textcard={url_name} /> </Grid> 
      
      </Grid>   
    </AccordionDetails>
</Accordion>
</Box>

) : (

<Box sx={{mb:2}}>
<Accordion elevation={3} sx={{mb:2, bgcolor: 'greydark.C500', }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header"  >
           <PanelLinePgx 
                marker = {<TextCardPgx textcard={drugname} />}
                source = { <TextCardPgx textcard={source} />}
           /> 
        </AccordionSummary> 
     
    <AccordionDetails sx={{}}>

       <Grid container sx={{mb:2, p:3, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',  borderRadius: '10px', border: 'groove', }}> 
          
        <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', mb:1, pl:0.5 }}> <TextCardBold textcard={g} /> </Grid>
      <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', mb:1 }}> <TextCardBold textcard={gt} /> </Grid>
      <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', mb:1 }}> <TextCardBold textcard={ph} /> </Grid>
      
      <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', pb:1}}> {genename} </Grid> 
      <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', pb:1}}> <TextCard textcard= {genotype} /> </Grid> 
      <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', pb:1}}> <TextCard textcard= {phenotype} /> </Grid> 

      <Grid size={12}>  <Divider role="presentation" sx={{mt:2, mb:2, borderBottomWidth: '1px', borderBottomColor: 'common.black' }}/> </Grid>

      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',mb:0.5 }}> <TextCardBold textcard={gl} /> </Grid>
      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',pb:1}}>  <TextCard textcard={gl_name} /> </Grid> 
      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',mb:0.5}}> <TextCardBold textcard={pop} /> </Grid>
      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',pb:1}}>  <TextCard textcard={pop_name} /> </Grid> 

      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',mb:0.5 }}> <TextCardBold textcard={imp} /> </Grid>
      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',pb:1}}>  <TextCard textcard={imp_name} /> </Grid> 
      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', mb:0.5}}> <TextCardBold textcard={rec} /> </Grid>
      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',pb:1}}>  <TextCard textcard={rec_name} /> </Grid> 
      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',mb:0.5 }}> <TextCardBold textcard={clas} /> </Grid>
      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',pb:1}}>  <TextCard textcard={clas_name} /> </Grid> 

      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',mb:0.5}}> <TextCardBold textcard={alt} /> </Grid>
      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',pb:1}}>  <TextCard textcard={alt_name} /> </Grid> 
      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', mb:0.5}}> <TextCardBold textcard={url} /> </Grid>
      <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start',pb:1}}>  <TextCard textcard={url_name} /> </Grid> 
          
      
      </Grid>   
    </AccordionDetails>
</Accordion>

  </Box>

    )
  )
  }